import { render, staticRenderFns } from "./PaypalBtn.vue?vue&type=template&id=59053ac6&scoped=true&"
import script from "./PaypalBtn.vue?vue&type=script&lang=ts&"
export * from "./PaypalBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59053ac6",
  null
  
)

export default component.exports